// extracted by mini-css-extract-plugin
module.exports = {"modal":"Differences_modal__2oki8","footer":"Differences_footer__2pkV3","table":"Differences_table__DXc6h","tableCell":"Differences_tableCell__furc8"};